module.exports = __webpack_public_path__ + "static/media/bcit.3b974bab.png";